const Marquee = ({ items }) => {
  const row = items.join("  ✦  ") + "  ✦  ";
  return (
    <div className="relative overflow-hidden border-y border-gold/20 bg-coal/60 py-5" data-testid="destinations-marquee">
      <div className="flex w-max animate-marquee whitespace-nowrap will-change-transform">
        <span className="font-display text-lg tracking-[0.2em] text-gold/90" aria-hidden={false}>{row}</span>
        <span className="font-display text-lg tracking-[0.2em] text-gold/90" aria-hidden={true}>{row}</span>
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-ink to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-ink to-transparent" />
    </div>
  );
};

export default Marquee;
